module.exports = __webpack_public_path__ + "static/media/hero.e23c5008.png";